import styled from '@emotion/styled'
import { Checkbox } from 'antd'
import { useCallback, useState } from 'react'
import Button from '../../components/common/Button'
import Modal, { ModalProps } from '../../components/common/Modal'
import Text from '../../components/common/Text'
import { BACKGROUND, FONT_BLACK, PRIMARY } from '../../constant/colors'
import { mobile } from '../../utils/responsive-helper'

const Layout = styled.div`
  padding: 48px 98px;
  ${mobile} {
    width: calc(100vw - 32px);
    padding: 16px;
    padding-top: 24px;
    .header {
      padding-right: 32px;
    }
  }
`

const Header = styled.div`
  text-align: center;
  margin-bottom: 16px;
`

const Content = styled.div`
  padding: 24px;
  margin-bottom: 16px;
  border-radius: 8px;
  background-color: ${BACKGROUND};
  ${mobile} {
    padding: 16px;
  }
`

const ContentScroll = styled.div`
  height: calc(55vh - 48px);
  max-width: 534px;
  overflow-y: auto;
`

export const Footer = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;

  .check-box {
    display: flex;
    align-self: flex-start;
    align-items: flex-start;
    margin-bottom: 32px;

    .ant-checkbox {
      /* margin-top: 6px; */
      background-color: ${PRIMARY};
    }
    .ant-checkbox-checked .ant-checkbox-inner {
      background-color: ${PRIMARY};
    }
    .ant-checkbox,
    .ant-checkbox-checked::after,
    .ant-checkbox-input + .ant-checkbox-inner,
    .ant-checkbox-wrapper:hover .ant-checkbox-inner,
    .ant-checkbox:hover .ant-checkbox-inner,
    .ant-checkbox-input:focus + .ant-checkbox-inner {
      border-color: ${PRIMARY};
      border-radius: 2px;
      width: 24px;
      height: 24px;
    }
    .ant-checkbox-checked .ant-checkbox-inner::after {
      top: 58%;
      left: 30%;
      transform: rotate(45deg) scale(1.5) translate(-50%, -50%);
    }
  }

  ${mobile} {
    .check-box {
      margin-bottom: 16px;
    }
  }
`

type ModalAcceptPrivacyProps = {
  onConfirmClick: () => void
  onCloseClick: () => void
} & Required<Pick<ModalProps, 'visible'>>
const ModalAcceptPrivacy = (props: ModalAcceptPrivacyProps) => {
  const { visible, onConfirmClick, onCloseClick } = props
  const [isAccept, setIsAccept] = useState(false)
  const onCancel = useCallback(() => {
    onCloseClick()
    setIsAccept(false)
  }, [onCloseClick])

  const onConfirm = useCallback(() => {
    onConfirmClick()
    setIsAccept(false)
  }, [onConfirmClick])
  return (
    <Modal
      visible={visible}
      onCancel={onCancel}
      style={{
        padding: 0,
      }}
      hideFooter
    >
      <Layout>
        <Header>
          <Text size={30} type="Bold" color={FONT_BLACK}>
            หนังสือยินยอม
          </Text>
        </Header>
        <Content>
          <ContentScroll>
            ด้วยการเลือกและส่งรายละเอียดของสวัสดิการยืดหยุ่นนี้
                    ข้าพเจ้าขอยืนยันและตกลงตามข้อตกลงดังต่อไปนี้ <br />
          1. ข้าพเจ้าได้อ่าน ทำความเข้าใจ และยอมรับในข้อตกลงและเงื่อนไข
                    ขั้นตอนการดำเนินการตลอดจนถึงรายละเอียดของสวัสดิการยืนหยุ่นที่ทางบริษัทฯ
                    ได้จัดเตรียมให้และสื่อสารกับข้าพเจ้า
                    โดยข้าพเจ้ามีสิทธิที่จะเข้าร่วมในโปรแกรมสวัสดิการยืดหยุ่นดังกล่าว <br />
           2. โดยการกดปุ่ม “ยืนยัน”
                    ข้าพเจ้าได้เลือกและมีความประสงค์ที่จะใช้สวัสดิการที่ข้าพเจ้าได้เลือกกับตัวข้าพเจ้าและครอบครัวของข้าพเจ้า
                    สวัสดิการที่ข้าพเจ้าได้เลือกนั้นอยู่ในการใช้ดุลยพินิจ
                    การพิจารณา และ การตัดสินใจเลือกของข้าพเจ้าเอง  <br />
           3. เมื่อการลงทะเบียนเสร็จสิ้นและทางบริษัทฯ
                    ได้ยอมรับการลงทะเบียนดังกล่าว
                    ข้าพเจ้ายอมรับและตกลงว่าข้าพเจ้าไม่สามารถทำการเปลี่ยนแปลงใด
                    ๆ
                    ในสวัสดิการที่ข้าพเจ้าเลือกจนกระทั่งรอบระยะเวลาการเลือกและลงทะเบียนรอบใหม่ตามที่บริษัทฯ
                    กำหนด
                    อย่างไรก็ตามการเปลี่ยนสวัสดิการจะสามารถดำเนินการได้ในกรณีที่มีเหตุการณ์ที่เปลี่ยนแปลงในชีวิตตามที่ได้มีการกำหนดโดยบริษัท
                    หากข้าพเจ้าไม่ได้ทำการเลือกสวัสดิการในช่วงระยะเวลาการลงทะเบียนที่บริษัทกำหนด  <br />
           4. ข้าพเจ้ารับทราบและยอมรับว่าให้ถือว่าข้าพเจ้าได้เลือกสวัสดิการชุดมาตรฐาน
                    ข้าพเจ้ารับทราบและยอมรับในข้อกำหนดของสิทธิประโยชน์ประกันกลุ่มของข้าพเจ้าจากบริษัทผู้ให้ประกัน
                    ซึ่งสิทธิประโยชน์ทางด้านประกันนั้นจะเป็นไปตามเงื่อนไขและข้อตกลงของบริษัทประกัน
                    ในกรณีที่มีข้อขัดแย้งระหว่างเงื่อนไขและข้อตกลงของประกันกับทางระบบสวัสดิการยืดหนุ่น
                    ให้อ้างอิงเงื่อนไขและข้อตกลงของบริษัทประกันเป็นหลัก  <br />
           5. ข้าพเจ้าเข้าใจและยอมรับว่าระบบสวัสดิการอาจจะมีการเปลี่ยนแปลงโดยบริษัท
                    ซื่ง บริษัทฯ ขอสงวนสิทธิที่จะยกเลิก ยุติ แก้ไข หรือ
                    ปรับเปลียนข้อตกลงได้ตลอดเวลาโดยไม่จำเป็นต้องแจ้งให้ทราบล่วงหน้า
                    ในกรณีนี้เช่นนี้ข้าพเจ้ายินยอมที่จะผูกพันตามการแก้ไขของข้อตกลงดังกล่าวทุกกรณี  <br />
           6. ข้าพเจ้าเข้าใจและยอมรับว่าการเลือกสวัสดิการบางรายการจะก่อให้เกิดภาษีส่วนบุคคล
                    ข้าพเจ้าเข้าใจและยอมรับว่าภาษีใด ๆ
                    ที่มีผลสืบเนื่องมาจากการเลือกสวัสดิการนั้นจะเป็นภาระของข้าพเจ้า <br />
           7. ข้าพเจ้าเข้าใจและยอมรับว่าการมีสิทธิของข้าพเจ้าในการเลือกสวัสดิการภายใต้สวัสดิการยืดหยุ่นจะสิ้นสุดลง
                    ณ วันที่มีการเลิกจ้าง หรือ สิ้นสุดสภาพการจ้างงานของข้าพเจ้า
                    ในกรณีเช่นนี้
                    สิทธิในสวัสดิการของข้าพเจ้าจะถูกนำไปคำนวณตามสัดส่วนระยะเวลาการทำงานกับบริษัทฯ
                    โดยข้าพเจ้ายินยอมที่จะชำระเงินคืนตามสวัสดิการที่ข้าพเจ้าได้ใช้สิทธิเกิน  <br />
          ในการกดปุ่ม “ยืนยัน” ข้าพเจ้ายืนยันว่าข้าพเจ้าได้อ่าน
                    ทำความเข้าใจ และยอมรับในข้อตกลงและเงือนไขตามประกาศข้างต้น
          </ContentScroll>
        </Content>
        <Footer>
          <Checkbox
            className="check-box"
            checked={isAccept}
            onChange={(v) => {
              setIsAccept((prev) => !prev)
            }}
            autoFocus={true}
          >
            <Text size={18} color={FONT_BLACK}>
              ฉันยืนยันเลือกแบบแผนประกันนี้ด้วยตัวเอง
            </Text>
          </Checkbox>
          <Button onClick={onConfirm} disabled={!isAccept}>
            ตกลง
          </Button>
        </Footer>
      </Layout>
    </Modal >
  )
}

export default ModalAcceptPrivacy
